import {
  POLISHING_HISTORY_FAILED,
  POLISHING_HISTORY_REQUEST,
  POLISHING_HISTORY_SUCCESS,
} from "../../../../actions/Factory/Polishing/polishingHistory/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const polishingHistoryReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case POLISHING_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case POLISHING_HISTORY_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case POLISHING_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
